import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import {
  WithSettings,
  WithSettingsConstructor,
} from "../../setting/models/WithSettings";
import { Page } from "./Page";

export interface PageCreateConstructor
  extends Omit<
      Page,
      | "id"
      | "domain"
      | "category"
      | "domain_id"
      | "category_id"
      | "settings"
      | "categories"
      | "tags"
      | "monthly_price"
      | "yearly_price"
      | "stripe_product_id"
      | "full_url"
    >,
    WithSettingsConstructor {
  domain_id: Option;
  category_id: Option;
  featured_image_file?: FileList | null;
}

export class PageCreate
  extends WithSettings
  implements
    Omit<
      Page,
      | "id"
      | "domain"
      | "category"
      | "categories"
      | "tags"
      | "monthly_price"
      | "yearly_price"
      | "stripe_product_id"
      | "full_url"
    >
{
  public readonly title: string;
  public readonly slug: string;
  public readonly body: string;
  public readonly domain_id: string;
  public readonly category_id: string;
  public readonly featured_image: string | null;
  public readonly featured_image_file?: File | null;

  constructor(props: PageCreateConstructor) {
    super(props);
    this.title = props.title;
    this.slug = props.slug;
    this.body = props.body;
    this.domain_id = props.domain_id.value;
    this.category_id = props.category_id.value;
    this.featured_image = props.featured_image ?? null;
    this.featured_image_file = props.featured_image_file?.[0] ?? null;
  }

  toFormData(): FormData {
    const formData = new FormData();

    console.log('THIS', this);
    formData.append("title", this.title);
    formData.append("slug", this.slug);
    formData.append("body", this.body);
    formData.append("domain_id", this.domain_id);
    formData.append("category_id", this.category_id);

    if (this.featured_image_file) {
      formData.append("featured_image_file", this.featured_image_file);
    }

    if (this.featured_image) {
      formData.append("featured_image", this.featured_image);
    }

    this.settings.forEach((setting, index) => {
      formData.append(`settings[${index}][key]`, setting.key);
      formData.append(`settings[${index}][value]`, String(setting.value));
    });

    return formData;
  }
}
